<template>
  <div class="component-detail">
    <div class="detail-header flex-container flex-row flex-verti-top flex-horiz-apart">
      <div class="header-left">
        <div class="name-and-3d flex-container flex-row flex-verti-center">
          <h3 class="detail-name line-no-wrap" :title="componentName">
            {{componentName}}
          </h3>
          <img
            class="icon-3d"
            :class="{'icon-3d-disabled':!canShow3D}"
            alt=""
            :src="require('@/assets/image/3dview.svg')"
            @click="openThreeDialog" />
        </div>
        <div class="flex-align-center">
          <span>{{ $t('component.category') }}</span>
          <gjw-category-display v-if="softwareCode==='AppGbr'" :node-code="detail.softwareCategoryCode" node-key="code" :plat-source-arr="platCategories" />
          <gjw-category-display v-if="softwareCode==='bimmake'" :node-code="detail.spaceCategoryId" :plat-source-arr="platCategories" />
          <gjw-category-display v-else :node-code="detail.gjwCategoryId" :plat-source-arr="platCategories" />
        </div>
      </div>
      <slot name="buttons"></slot>
    </div>
    <div class="thumbnails">
      <el-carousel
        class="view-container custom-carousel"
        height="168px"
        :arrow="thumbnails && thumbnails.length > 0 ? 'always' : 'never' "
        :indicator-position="thumbnails && thumbnails.length > 0 ? 'outside': 'none'"
        trigger="click" >
        <el-carousel-item  v-for="(item, index) in thumbnails" :key="index">
          <img class="thumbnail" :src="item" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="placeholders" v-if="showPlaceholders">
      <el-collapse v-model="activeName">
        <el-collapse-item :title="$t('component.placeholderTitle')" name="placeholder">
          <ul class="placeholders-wrap">
            <li class="placeholder" v-for="(placeholder,i) in placeholders" :key="i">
              <p class="title line-no-wrap">
                {{ placeholder.discipline ? `${switchPlaceholderType(placeholder.placeholderType)}-${switchPlaceholderMajor(placeholder.discipline)}` : `${switchPlaceholderType(placeholder.placeholderType)}` }}
              </p>
              <img class="holder-thumbnail" :src="placeholderThumbnail(placeholder.thumbnail)" alt="">
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
    <detail-properties
        v-if="showProperties"
        class="properties"
        :properties="properties"
        :family-types="familyTypes"
        :current-type="currentType"
        @change-type="changeFamilyType" />
    <detail-three-dialog
      v-if="show3D"
      :show-dialog="show3D"
      :platform="platform"
      :is-bimface="isSkp"
      :store-id="detail.storeId"
      :core-resource-id="detail.coreResourceId"
      :core-resource-version-id="detail.digitalComponentId || detail.coreResourceVersionId"
      :current-type="currentType"
      :geometry-data="geometryData"
      :view-token="viewToken"
      :three-api="threeApi"
      :input-parameters="inputParameters"
      @close-dialog="show3D=false"
      />
  </div>
</template>
<script>
import DetailProperties from '@/components/business/compDetail/DetailProperties'
import DetailThreeDialog from '@/components/business/compDetail/DetailThreeDialog'
import GjwCategoryDisplay from '@/components/business/compDetail/GjwCategoryDisplay.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'ComponentDetail',
  components: { DetailProperties, DetailThreeDialog, GjwCategoryDisplay },
  data() {
    return {
      canShow3D: false, // 切换详情的时候确保detail和properties是最新的再展示
      platform: null,
      component: {},
      activeName: 'placeholder',
      show3D: false
    }
  },
  computed: {
    ...mapGetters({
      softwareCode: 'softwareCode',
      platCategories: 'componentList/platCategories',
      detail: 'componentDetail/DETAIL',
      geometryData: 'componentDetail/GEOMETRY_DATA',
      viewToken: 'componentDetail/VIEW_TOKEN',
      inputParameters: 'componentDetail/INPUT_PARAMETERS',
      placeholders: 'componentDetail/PLACEHOLDERS',
      properties: 'componentDetail/PROPERTIES',
      familyTypes: 'componentDetail/FAMILYTYPES'
    }),
    componentName() {
      const comp = this.component
      return comp.componentFamilyTypeName ? `${comp.name}_${comp.componentFamilyTypeName}` : comp.name
    },
    categoryName() {
      const comp = this.component
      const categoryNames = comp.gjwCategoryNames
      return categoryNames && categoryNames.length ? categoryNames.join('/') : ''
    },
    thumbnails() {
      return this.isSkp ? [`${process.env.VUE_APP_STATIC_HOST}/${this.component.thumbnail}`] : this.$store.getters['componentDetail/THUMBNAILS']
    },
    isSkp() {
      return this.component.suffix === 'skp'
    },
    currentType: {
      get() {
        return this.$store.getters[`componentDetail/CURRENTTYPE`]
      },
      set(val) {
        this.setCurrentType(val)
      }
    },
    threeApi() {
      return '/digital_components/gcmp_server/display_data'
    },
    showPlaceholders() {
      return this.platform === 'g' && !this.isSkp && this.detail.hasPlaceholder && this.placeholders && this.placeholders.length > 0
    },
    showProperties() {
      return this.familyTypes.length && !this.isSkp
    },
  },
  methods: {
    ...mapMutations({
      setComponentId: 'componentDetail/SET_ID',
      setCurrentType: 'componentDetail/SET_CURRENT_TYPE',
      setDetail: 'componentDetail/SET_DETAIL',
      setViewToken: 'componentDetail/SET_VIEW_TOKEN'
    }),
    ...mapActions({
      loadDetail: 'componentDetail/LOAD_DETAIL',
      loadProperties: 'componentDetail/LOAD_PROPERTIES',
      loadPlaceholders: 'componentDetail/LOAD_PLACEHOLDERS',
      loadViewToken: 'componentDetail/LOAD_VIEW_TOKEN'
    }),
    // load:skp构件不需要请求接口
    async open(comp, platform) {
      try {
        this.canShow3D = false
        this.component = comp
        this.platform = platform
        this.setComponentId(comp.publicComponentId || comp.id)
        this.setDetail({})
        const detailQuery = {
          softwareCode: comp.softwareCode,
          softwareVersion: comp.softwareVersion,
          familyTypeName: comp.componentFamilyTypeName
        }
        await this.loadDetail(detailQuery)
        await this.loadProperties()
        this.canShow3D = true
        if (this.platform === 'g' && this.detail.hasPlaceholder) {
          await this.loadPlaceholders()
        }
        if (this.platform !== 'g' || this.detail.suffix === 'skp') {
          await this.loadViewToken()
        }
      } catch (error) {
        console.log(error)
      }
    },
    placeholderThumbnail(placeholder) {
      return `${process.env.VUE_APP_STATIC_HOST}/${placeholder}`
    },
    // 图例类型转换
    switchPlaceholderType(value) {
      switch (value) {
        case 'PROFILE': return this.$t('component.placeholderProfile')
        case 'ELEVATION': return this.$t('component.placeholderElevation')
        case 'PLAN': return this.$t('component.placeholderPlan')
      }
    },
    // 图例专业转换
    switchPlaceholderMajor(value) {
      switch (value) {
        case 'COMMON': return this.$t('component.placeholderCommon')
        case 'ELECTRIC': return this.$t('component.placeholderElectric')
      }
    },
    async changeFamilyType(selected) {
      const familyType = this.familyTypes.find(type => type.id === selected.id)
      // 先请求properties  保证gjw-three获取到准确的inputParameters
      await this.loadProperties(familyType)
      this.currentType = familyType
    },
    openThreeDialog() {
      if (this.canShow3D) {
        this.show3D = true
      }
    }
  },
  beforeDestroy() {
    this.setComponentId(null)
    this.setDetail({})
    this.setViewToken(null)
    this.setCurrentType({})
  }
}
</script>
<style lang='less' scoped>
.component-detail{
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
/deep/.el-collapse-item__content{
    padding-bottom: 0;
  }
 /deep/.el-collapse-item__wrap{
    border-bottom: unset;
    padding-bottom:1rem;
  }
/deep/.el-collapse-item__header{
    font-size: 1rem;
    padding: 0 8px;
    background-color: @bg-grey-dark;
    height: 32px;line-height: 32px;
  }

.detail-header{
  color: @theme-text-main;
  flex-shrink: 0;
  width: 100%;
  padding: 0 8px 8px;
  .header-left{
    width: 80%;
  }
  .name-and-3d{
    padding-bottom: 4px;
    .icon-3d{
      margin-left: 4px;
      width: 20px;height: 20px;
      cursor: pointer;
      &.icon-3d-disabled{
        cursor: not-allowed;
      }
    }
  }
}
.detail-name{
  font-size: 1.2857rem;
}
.detail-category{
  font-size: 1rem;
  color: #787A83;
  font-weight: normal;
}
.thumbnails{
  padding: 8px 8px 0;
  .thumbnail{
    padding: 8px 0;
    height: 152px;
  }
}
.placeholders{
  padding-top: 8px;
  .placeholders-wrap{
    background-color: #fff;
    padding: 8px;
    width: 100%;
    overflow-x: auto;
  }
  .placeholder{
    float: left;
    height: 104px;
    width: 88px;
    margin: 0 6px;
  }
  .title {
    width: 100%;
    text-align: center;
    line-height: 16px;
  }

  .holder-thumbnail{
    border: 1px solid @theme-border-color;
    width: 86px;height: 86px;
  }
}
.properties{
  flex-grow: 1;
  min-height: 1px;
}
</style>
